import {
  GET_SERVICES_FAIL,
  GET_SERVICES_REQUEST,
  GET_SERVICES_SUCCESS,
  ADD_SERVICE_FAIL,
  ADD_SERVICE_REQUEST,
  ADD_SERVICE_SUCCESS,
  EDIT_SERVICE_FAIL,
  EDIT_SERVICE_REQUEST,
  EDIT_SERVICE_SUCCESS,
  DELETE_SERVICE_FAIL,
  DELETE_SERVICE_REQUEST,
  DELETE_SERVICE_SUCCESS
} from "./actions";
import { IService } from "app/api/types";

interface IState {
  isLoading: boolean;
  serviceList: IService[];
}
const initialState: IState = {
  serviceList: [],
  isLoading: false
};

const servicesReducer = (
  state = initialState,
  action: { type: any; payload: any }
) => {
  switch (action.type) {
    case GET_SERVICES_REQUEST:
    case EDIT_SERVICE_REQUEST:
    case ADD_SERVICE_REQUEST:
      return {
        ...state,
        isLoading: true
      };

    case DELETE_SERVICE_REQUEST:
      return {
        ...state
      };

    case ADD_SERVICE_FAIL:
    case GET_SERVICES_FAIL:
    case EDIT_SERVICE_FAIL:
      return {
        ...state,
        isLoading: false
      };

    case DELETE_SERVICE_FAIL:
      return {
        ...state,
        isLoading: false
      };

    case GET_SERVICES_SUCCESS:
      return {
        ...state,
        serviceList: action.payload,
        isLoading: false
      };

    case ADD_SERVICE_SUCCESS:
    case EDIT_SERVICE_SUCCESS:
      return {
        ...state,
        isLoading: false
      };

    case DELETE_SERVICE_SUCCESS:
      return {
        ...state,
        isLoading: true
      };
    default:
      return state;
  }
};

export default servicesReducer;
